<template>
<div id="container" class="erfindergeschichten">
    <div class="fullscreen_background">
        <img src="/static/assets/erfindergeschichten/Hintergrund.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/erfindergeschichten/Moeve.png" />
    </div> -->

    <div class="alma z30">
        <img class="img" src="/static/assets/erfindergeschichten/Alma.png" />
    </div>
    <div class="vielleser z30">
        <img class="img" src="/static/assets/erfindergeschichten/Frau_Vielleser.png" />
    </div>
    <div class="libero z30">
        <img class="img" src="/static/assets/erfindergeschichten/Libero.png" />
    </div>
    <div class="hugi z30">
        <img class="img" src="/static/assets/erfindergeschichten/Hugi.png" />
    </div>
	<div class="gigi z30">
        <img class="img" src="/static/assets/erfindergeschichten/Gigi.png" />
    </div>
    <div class="buecherwurm z31">
        <img class="img" src="/static/assets/erfindergeschichten/Herr_Buecherwurm.png" />
    </div>
    <div class="lampe lampe_animation z29">
    </div>
	<div class="apfel z30 apa_animation">
    </div>
	<div class="buecher z30 buecher_animation">
    </div>
    <router-link to="/pferdegeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/ninjageschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/erfindergeschichten/Geschichte.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Hugi_Watt_LANGSAM2.mp3" jsonurl="/static/assets/geschichten/hugi_ausgabe4.json" content=".erfindergeschichten" target="erfindergeschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="erfindergeschichten_target">
        <p>Bumms! Alaaarm! Was für ein Lärm! Hugi Watt legte sein Buch beiseite. Was hatte seine Mutter da wieder angerichtet? Konnte sie nicht wie andere Mütter sein? Einfach ganz normal? Bei seinen Freunden war es nie so laut, da dröhnte höchstens mal der Staubsauger oder surrte die Waschmaschine. Aber seine Mutter ließ es richtig krachen! Sie war Erfinderin und hatte schon allerhand erfunden: eine Apfelpflückmaschine, einen Schneeschipproboter und eine Mülldrohne, die den Mülleimer zur Mülltonne trug und dort entleerte. Ein Theater! Die Apfelpflückmaschine pflückte zwar wie wild Äpfel, legte sie aber nicht in Körbe, sondern warf sie in den Nachbargarten, wo sie dem gemütlich lesenden Herrn Bücherwurm direkt auf die Nase plumpsten. Auch der Schneeschipproboter war superfleißig. Seinen Riesenschneehaufen aber setzte er gerade vor die Tür des Nebenhauses, so dass Frau Vielleser, die gerade den Bus zu ihrer Buchhandlung nehmen wollte, das Haus nicht mehr verlassen konnte. Und die Mülldrohne? Die verwechselte den Kamin von Herrn Schmöker mit der Mülltonne und so ergoss sich — igitt! — durch dessen Kamin eine Ladung Biomüll! Natürlich just in dem Moment, in dem Herr Schmöker dort saß und seinen Kindern vorzulesen begann! </p>
<p>
Ja, seine Mutter Gigi Curie war eine begnadete Erfinderin, seufzte Hugi Watt. Vorsichtig betrat er ihre Werkstatt. In der Mitte des Raumes lag eine riesige rote Kiste, die aufgeregt blinkte und ohrenbetäubende Alarmtöne von sich gab. Und obgleich das schon laut genug war, bellte Libero Archi, der Hund der Familie, noch gegen den Alarm an. Gigi Curie und ihre Assistenten Dubix Otto und Alma Edison hingegen versuchten die schwere Kiste wiederaufzurichten. Hugi Watt half ihnen und mit vereinten Kräften brachten sie das Monstrum wieder zum Stehen. Der Alarmlärm versiegte. „Wuff!“ Libero war mit seinem Erfolg zufrieden und legte sich wieder in sein Körbchen. „Was hast du denn da wieder zusammengebastelt, Mama?“, fragte Hugi Watt genervt. „Eine Weltneuheit! Einen Bücherwunschautomat. Den haben wir uns für dich und unsere Nachbarn ausgedacht. Als Entschuldigung für die kleinen Malheurs.“, rief seine Mutter aufgeregt. Hugi Watt war baff. So eine Erfindung wäre ja ganz wunderbar! „Aber warum ist der Automat umgefallen?“, fragte er eifrig. Gigi Curie und ihre Assistenten blickten sich ratlos an und zuckten mit den Schultern. „Wir wissen es nicht. Es sollte so funktionieren: Du steigst auf die Leiter des Automaten und sprichst oben in den blinkenden Trichter deinen Bücherwunsch. Dann drückst du den leuchtenden Knopf hier. Jetzt spielt der Automat passende Musik, sucht gleichzeitig das Buch, transportiert es zu dieser Klappe und kündigt es mit lautem Pieps an. Aber …“ 
</p>
<p>Gigi Curie stieg auf die Leiter, sprach in den riesigen Trichter, stieg wieder runter, drückte den Knopf und schaute den Automaten erwartungsvoll an. Bumms! Alaaarm! Da lag er wieder. Alles wieder von vorne! Als der Automat erneut stand, erklomm Hugi Watt die Leiter, beugte sich tief in den Trichter, murmelte etwas und drückte den Knopf. Der Automat begann den Song „Ohne Krimi geht die Mimi nie ins Bett“ zu spielen, piepste bald und spuckte das Buch aus, das sich Hugi Watt schon lange gewünscht hatte! Alle applaudierten begeistert! Gigi Curies Bücherwunschautomat wurde bald zum Welterfolg und zu ihrer berühmtesten Erfindung. Aber wie hatte Hugi Watt es geschafft, ihn zum Laufen zu bringen? Es ist ganz einfach: Im Gegensatz zu seiner Mutter hatte er nicht vergessen, dem Bücherwunschautomaten das Codewort aller Leseratten zu nennen. Wer also je vor dem Trichter eines Bücherwunschautomaten steht, der sage einfach: </p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'erfindergeschichten',
  data () {
    return {
      who: 'erfindergeschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Hugi_Watt_Titel.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Watt_Atmo2.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* erfindergeschichten */
.erfindergeschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.erfindergeschichten .himmel { display: block !important; }

.erfindergeschichten .geschichte { position: absolute; top: 170px; left:50.3%;  }

.erfindergeschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.erfindergeschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* erfindergeschichten .schwimmer {position: absolute; left: 28%; top: 39%; } */
.erfindergeschichten .schwimmer {position: absolute; left: 25%; top: 12%; }
.erfindergeschichten .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}

.erfindergeschichten .vielleser {position: absolute;     left: 193px;
    top: 704px;}
.erfindergeschichten .vielleser {animation: vielleser_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes vielleser_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.alma {
    position: absolute;
    top: 580px;
    left: 4px;
}
.erfindergeschichten .gras {position: absolute; /* left:0; bottom: -5px;*/ left: -25%; bottom: -25%;}
.erfindergeschichten .libero {position: absolute;     left: 1670PX;
    bottom: 413PX;}
.erfindergeschichten .libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes libero_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.erfindergeschichten .koechin {position: absolute; left: 37%; bottom: 26%;}
.erfindergeschichten .hugi {position: absolute;     right: 1258px;
    bottom: 35px;;}
.erfindergeschichten .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .erfindergeschichten .dubix {position: absolute; left: 355px; bottom: 100px;}
.erfindergeschichten .dubix {animation: hugi_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.erfindergeschichten .alma {position: absolute; right: 955px; bottom: 643px;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .erfindergeschichten .gigi {position: absolute; left: 469px;
    bottom: 340px;}
.erfindergeschichten .gigi {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.erfindergeschichten .wasserfall {position: absolute; /* left: 23%; bottom: 6%; */}
.erfindergeschichten .moeve { position: absolute; top: 250px; left: 600px; }
.erfindergeschichten .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.erfindergeschichten .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.erfindergeschichten .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.erfindergeschichten .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.erfindergeschichten .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.erfindergeschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
.lampe {
    top: 467px;
    left: 320px;
    position: absolute;
}
.lampe_animation {
  width: 180px;
  height: 193px;
  background: url('/static/assets/erfindergeschichten/lampe_animation.png') top center;
  animation-delay: 1s;
  animation: lampe_animation 5s steps(11) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes lampe_animation {
    100% { background-position: 0 -2123px; }
}
.apfel {position: absolute; top: 218px; left: 50px;}
.apa_animation {
  width: 191px;
  height: 432px;
  background: url('/static/assets/erfindergeschichten/apa_animation.png') top center;
  animation-delay: 1s;
  animation: apa_animation 6s steps(26) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes apa_animation {
    100% { background-position: 0 -11232px; }
}	
.buecherwurm {
    position: absolute;
    top: 550px;
    left: 604px;
}
.buecher {
    position: absolute;
    top: 472px;
    left: 630px;
}
.buecher_animation {
  width: 329px;
  height: 365px;
  background: url('/static/assets/erfindergeschichten/ba_animation.png') top center;
  animation-delay: 1s;
  animation: ba_animation 5s steps(18) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes ba_animation {
    100% { background-position: 0 -6570px; }
}	
.erfindergeschichten #erfindergeschichten_target .current-word {
    color: #e8f5fd !important;
}
span { font-family: FrozenMemory; }
.geschichte .player { top: 670px !important;    left: 100px; }
.spacegeschichten .player {position: absolute !important;left: 95px !important;}
</style>




// WEBPACK FOOTER //
// src/components/Stromgeschichten.vue